import type { WizardActionButtonProps } from "../WizardContext";

export type WizardTertiaryButtonProps = WizardActionButtonProps;

/** Marker slot — Wizard reads props from this element rather than rendering it. */
export function WizardTertiaryButton(_props: WizardTertiaryButtonProps) {
  return null;
}
